{
  "appName": "21-526EZ disability compensation claim form",
  "entryFile": "./form-entry.jsx",
  "entryName": "526EZ-all-claims",
  "rootUrl": "/disability/file-disability-claim-form-21-526ez",
  "productId": "ebcf7274-ee64-4bc7-8365-d9ab2ec0323a"
}
